"use client";

import { useEffect, useState } from "react";
import Link from "./LocaleLink";
import { useLocale } from "./LocaleProvider";

const copy = {
  en: {
    intro:
      "We use cookies to improve your experience, analyse traffic and display embedded content. By clicking",
    accept: "Accept",
    outro: ", you agree to our use of cookies.",
    policy: "Privacy & Cookies Policy",
  },
  ro: {
    intro:
      "Folosim cookie-uri pentru a vă îmbunătăți experiența, a analiza traficul și a afișa conținut încorporat. Prin apăsarea butonului",
    accept: "Accept",
    outro: ", sunteți de acord cu utilizarea cookie-urilor.",
    policy: "Politica de confidențialitate și cookie-uri",
  },
} as const;

const COOKIE_KEY = "egodent_cookie_consent";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);
  const t = copy[useLocale()];

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_KEY);
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem(COOKIE_KEY, "accepted");
    setVisible(false);
    window.dispatchEvent(new Event("egodent-cookie-accepted"));
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-[9999] bg-black/95 backdrop-blur-md border-t border-white/10">
      <div className="container-px mx-auto py-4 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
        <p className="text-sm text-white/80 max-w-3xl">
          {t.intro} <strong>{t.accept}</strong>
          {t.outro}{" "}
          <Link
            href="/privacy"
            className="text-[#27E8A7] underline hover:text-white"
          >
            {t.policy}
          </Link>
        </p>

        <button
          onClick={acceptCookies}
          className="shrink-0 rounded-full bg-[#27E8A7] px-6 py-2 text-sm font-semibold text-black hover:opacity-90 transition"
        >
          {t.accept}
        </button>
      </div>
    </div>
  );
}
